import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import Currency from 'components/currency';
import { ILoyaltyCardTransaction } from 'state/loyalty/types';

import { DateAndTimeCell } from './datetime-cell';
import { PurchaseAmount, Reward, Rewards } from './transaction.styled';

const tagToMessageIdMap = new Map<string, string>([
  ['CHALLENGE_COMPLETE', 'challengeComplete'],
  ['DAYPART_CHALLENGED_COMPLETED', 'daypartChallengedCompleted'],
  ['FREQUENCY_CHALLENGED_COMPLETED', 'frequencyChallengedCompleted'],
  ['PRODUCT_CHALLENGED_COMPLETED', 'productChallengedCompleted'],
  ['HOCKEY_1', 'hockey1'],
  ['HOCKEY_2', 'hockey2'],
  ['HOCKEY_3', 'hockey3'],
  ['offerApplied', 'offerApplied'],
  ['RUTR_CAN_21', 'rutrPrize'],
  ['RUTR_CAN_21_2', 'rutrPrize'],
  ['RUTR_CAN_22', 'rutrPrize'],
  ['RUTR_US_22', 'rutrPrize'],
  ['RUTR_CAN_23', 'rutrPrize'],
  ['RUTR_US_23', 'rutrPrize'],
  ['MIGRATION_30', 'migration30'],
]);

export const useLocalizedTransactionTransformer = () => {
  const { formatMessage } = useIntl();

  const transactionTransformer = useCallback(
    (loyaltyCardTransaction: ILoyaltyCardTransaction) => {
      const {
        bonusPoints,
        timestamp: timeStamp,
        basketTotal,
        discountAmount = 0,
        pointsEarned,
        isCustomerServiceVisit,
        pointsUsed,
        tag,
      } = loyaltyCardTransaction;

      const purchaseAmount = (
        <PurchaseAmount>
          <Currency amount={basketTotal - discountAmount} />
        </PurchaseAmount>
      );

      const tagId = tagToMessageIdMap.get(tag);

      const rewards = (
        <Rewards>
          {bonusPoints && <Reward>{`+${bonusPoints} ${formatMessage({ id: 'bonus' })}!`}</Reward>}
          {pointsEarned && <Reward>{`+${pointsEarned}pts`}</Reward>}
          {pointsUsed && <Reward>{`-${pointsUsed}pts`}</Reward>}
          {isCustomerServiceVisit && <Reward>{`${formatMessage({ id: 'serviceVisit' })}!`}</Reward>}
          {tagId && <Reward>{`${formatMessage({ id: tagId })}`}</Reward>}
        </Rewards>
      );

      const dateTime = <DateAndTimeCell timeStamp={timeStamp} />;

      return { timeStamp, dateTime, rewards, purchaseAmount };
    },
    [formatMessage]
  );

  return transactionTransformer;
};
